export const signatureKey = "klarda-signature";
export enum EnumDuration {
  "1M" = "1M",
  "3M" = "3M",
  "6M" = "6M",
  "1Y" = "1Y",
  ALL = "ALL",
}
